module.exports = __webpack_public_path__ + "img/Sighet_Dunkelzelle_1kl.b97850bd.jpg";